export default "__VITE_ASSET__Chh5C5yL__"